import React, { useState, useEffect } from "react";
import { Table, Icon, Input } from "semantic-ui-react";
import { map } from "lodash";
import { Button } from "semantic-ui-react";
import "./TablePeriodos.css";
import { Tooltip } from "react-tooltip";

export function TablePeriodos(props) {
  const { periodos, deletePeriodo, updatePeriodo } = props;
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const [searchText, setSearchText] = useState("");
  const [realTimeSearch, setRealTimeSearch] = useState("");

  useEffect(() => {
    setSearchText(searchText.toLowerCase());
  }, [searchText]);

  const handleRealTimeSearchChange = (value) => {
    setRealTimeSearch(value);
    setCurrentPage(1);
  };

  useEffect(() => {
    setSearchText(realTimeSearch.toLowerCase());
  }, [realTimeSearch]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const formatFechaPeriodo = (fecha) => {
    const opciones = { month: "long", year: "numeric" };
    const fechaFormateada = new Date(fecha).toLocaleDateString(
      "es-ES",
      opciones
    );
    
    // Convertir la primera letra del mes a mayúscula
    return fechaFormateada.charAt(0).toUpperCase() + fechaFormateada.slice(1);
  };
  

  const formatFechaCiclo = (fecha) => {
    const opciones = { year: "numeric" };
    const fechaFormateada = new Date(fecha).toLocaleDateString(
      "es-ES",
      opciones
    );
    return fechaFormateada;
  };

  const filteredPeriodos = periodos.filter(
    (periodosE) =>
      `${formatFechaPeriodo(periodosE.fecha_inicio)}`
        .toUpperCase()
        .includes(searchText.toUpperCase()) ||
      `${formatFechaPeriodo(periodosE.fecha_fin)}`
        .toUpperCase()
        .includes(searchText.toUpperCase())
  );

  useEffect(() => {
    setSearchText(searchText.toUpperCase());
    if (searchText === "") {
      setCurrentPage(1);
    }
  }, [searchText, setCurrentPage]);

  useEffect(() => {
    const lastPage = Math.ceil(filteredPeriodos.length / itemsPerPage);
    if (currentPage > lastPage) {
      setCurrentPage(lastPage);
    }
  }, [filteredPeriodos, currentPage, setCurrentPage]);

  // Ordenar ciclos escolares por fecha de inicio de manera descendente
  const sortedPeriodosE = filteredPeriodos.sort((a, b) => {
    return new Date(b.fecha_inicio) - new Date(a.fecha_inicio);
  });

  const paginatedPeriodos = sortedPeriodosE.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  return (
    <div>
      <div className="buscar">
        <Icon name="search" className="bot" />
        <Input
          placeholder="Buscar por periodo"
          value={realTimeSearch}
          onChange={(e) => handleRealTimeSearchChange(e.target.value)}
          className="busper"
        />
      </div>
      <div>
        <Table className="table-users-admin">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>PERÍODO</Table.HeaderCell>
              <Table.HeaderCell>SEMESTRE</Table.HeaderCell>
              <Table.HeaderCell>CICLO ESCOLAR</Table.HeaderCell>
              <Table.HeaderCell>ACCIONES</Table.HeaderCell>
            </Table.Row>
          </Table.Header>

          <Table.Body>
            {map(paginatedPeriodos, (periodoo, index) => (
              <Table.Row key={index}>
                <Table.Cell>{`${formatFechaPeriodo(
                  periodoo.fecha_inicio
                )} - ${formatFechaPeriodo(periodoo.fecha_fin)}`}</Table.Cell>
                <Table.Cell>
                  {periodoo.tipo_semestre === "A"
                    ? "A   (Semestre impar)"
                    : "B   (semestre par)"}
                </Table.Cell>
                <Table.Cell>{`${formatFechaCiclo(
                  periodoo.ciclo_escolar_data.fecha_inicio
                )} - ${formatFechaCiclo(
                  periodoo.ciclo_escolar_data.fecha_fin
                )}`}</Table.Cell>
                <Actions
                  periodo={periodoo}
                  deletePeriodo={deletePeriodo}
                  updatePeriodo={updatePeriodo}
                />
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
      </div>
      <div style={{ textAlign: "center", marginTop: "10px" }}>
        <Button.Group>
          {Array.from({
            length: Math.ceil(periodos.length / itemsPerPage),
          }).map((_, index) => {
            const pageNumber = index + 1;
            const maxVisibleButtons = 4;
            const startPage = Math.max(
              1,
              currentPage - Math.floor(maxVisibleButtons / 2)
            );
            const endPage = Math.min(
              startPage + maxVisibleButtons - 1,
              Math.ceil(periodos.length / itemsPerPage)
            );
            const showStartEllipsis = startPage > 1;
            const showEndEllipsis =
              endPage < Math.ceil(periodos.length / itemsPerPage);

            //para evitar renderizar el botón si solo hay una página

            if (Math.ceil(periodos.length / itemsPerPage) === 1) {
              return null;
            }
            if (pageNumber >= startPage && pageNumber <= endPage) {
              return (
                <Button
                  key={pageNumber}
                  icon
                  active={currentPage === pageNumber}
                  onClick={() => handlePageChange(pageNumber)}
                >
                  {pageNumber}
                </Button>
              );
            } else if (showStartEllipsis && pageNumber === 1) {
              return (
                <Button key="startEllipsis" icon className="bordebotn">
                  {"..."}
                </Button>
              );
            } else if (
              showEndEllipsis &&
              pageNumber === Math.ceil(periodos.length / itemsPerPage)
            ) {
              return (
                <Button key="endEllipsis" icon className="bordebotn">
                  {"..."}
                </Button>
              );
            }
            return null;
          })}
        </Button.Group>
      </div>
    </div>
  );
}
function Actions(props) {
  const { periodo, deletePeriodo, updatePeriodo } = props;
  return (
    <Table.Cell textAlign="center">
      <div className="action-buttons">
        <Button
          data-tooltip-id="my-tooltip"
          data-tooltip-content="Actualizar datos periodo"
          icon
          className="yellow"
          onClick={() => {
            updatePeriodo(periodo);
          }}
        >
          <Icon name="pencil" style={{ color: "white" }}></Icon>
        </Button>
        <Button
          data-tooltip-id="my-tooltip"
          data-tooltip-content="Eliminar periodo"
          icon
          negative
          onClick={() => {
            deletePeriodo(periodo);
          }}
        >
          <Icon name="trash" style={{ color: "white" }}></Icon>
        </Button>
        <Tooltip id="my-tooltip" />
      </div>
    </Table.Cell>
  );
}
